import { render, staticRenderFns } from "./GameDetails.vue?vue&type=template&id=3746e8f7&scoped=true"
import script from "./GameDetails.vue?vue&type=script&lang=js"
export * from "./GameDetails.vue?vue&type=script&lang=js"
import style0 from "./GameDetails.vue?vue&type=style&index=0&id=3746e8f7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3746e8f7",
  null
  
)

export default component.exports